import HandleSubmit from "./HandleSubmit";
import EmptyCart from "../empty_cart/Handle_empty_cart";

const Server_side_submit = async (
  e,
  props,
  paymentMethod,
  email,
  name,
  lastname,
  phone,
  address1,
  address2,
  user,
  total,
  Note,
  City,
  ZIP,
  handleAlert,
  setGif,
  history,
  delivery,
  setForceRerender,
  cart,
  setCart,
  empty_cart,
  userInfo
) => {
  setGif(true);
  let newCart = [];
  e.preventDefault();

  if (paymentMethod === "In Cash") {
    let response = await HandleSubmit({
      email,
      name,
      lastname,
      phone,
      address1,
      address2,
      user,
      cart,
      total,
      Note,
      City,
      ZIP,
      delivery,
      paymentMethod,
    });

    if (response) {
      handleAlert({
        show: true,
        type: "success",
        text: "The payment was successful...",
      });
      history.push("/complete");
      setForceRerender((prevState) => !prevState);
      setGif(false);
      let response2 = await EmptyCart({ user, userInfo, empty_cart });
      if (response2) {
        console.clear();
      }
      setCart(newCart);
    } else {
      handleAlert({
        show: true,
        type: "error",
        text: "The payment failed...",
      });
      setGif(false);
    }
  } else {
    const stripeResponse = await props.stripe.createToken().catch((error) => {
      console.clear();
    });

    const { token } = stripeResponse;

    if (token) {
      const { id } = token;
      let response = await HandleSubmit({
        stripeTokenId: id,
        email,
        name,
        lastname,
        phone,
        address1,
        address2,
        user,
        cart,
        total,
        Note,
        City,
        ZIP,
        paymentMethod,
        delivery,
      });

      if (response) {
        handleAlert({
          show: true,
          type: "success",
          text: "The payment was successful...",
        });
        setGif(false);
        history.push("/complete");
        setForceRerender((prevState) => !prevState);
        setCart([]);
      } else {
        handleAlert({
          show: true,
          type: "error",
          text: "The payment failed...",
        });
        setGif(false);
        console.clear();
      }
    }
  }
};

export { Server_side_submit as default };
